import { z } from '@harvestiq/zod';

export const sendOptOutConfirmationRequestBodySchema = z.object({
  recipientId: z.string().uuid(),
});

export type SendOptOutConfirmationRequestBody = z.infer<
  typeof sendOptOutConfirmationRequestBodySchema
>;
